export default "__VITE_ASSET__S3tIFnx7__"